import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Button, Select, Typography } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import moment from 'moment'
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { http } from '@services/http'
import {
	formatNumberWithSpaces,
	numberWithSpacesIntl,
	removeSpaces,
	formatInputNumber,
} from '@utils/numberWithSpaces'

import ErrorModal from './ErrorModal'
import SuccessModal from './SuccessModal'



const InvoiceVendorPaymentModal = ({ visible, onClose, data }) => {
	const { t } = useTranslation()

	const {
		uzsCash: uzdCashNotAdmin,
		department,
		usdCash: usdCashNotAdmin,
		roleNames,
		terminalCash: terminalCashNotAdmin,
		getMe,
	} = useSelector((state) => state.main)

	console.log('getMe', getMe)
	console.log('Data From ViewPurchaseIncomingModal in Payment', data)

	const successRef = useRef()
	const errorRef = useRef()

	const [loading, setLoading] = useState(false)
	const [docDate, setDocDate] = useState(moment().format('YYYY-MM-DD'))
	const [comment, setComment] = useState('')
	const [bpDebt, setBpDebt] = useState('')
	const [bpDebtFc, setBpDebtFc] = useState('')
	const [docRate, setDocRate] = useState('')
	const [usdCardNumber, setUsdCardNumber] = useState('')
	const [terminalCardNumber, setTerminalCardNumber] = useState('')
	const [uzsAmount, setUzsAmount] = useState('')
	const [usdAmount, setUsdAmount] = useState('')
	const [terminalAmount, setTerminalAmount] = useState('')
	const [clickAmount, setClickAmount] = useState('')
	const [uzsCashAcc, setUzsCashAcc] = useState('')
	const [usdCashAcc, setUsdCashAcc] = useState('')
	const [terminalCashAcc, setTerminalCashAcc] = useState('')
	const [clickCashAcc, setClickCashAcc] = useState('')

	const totalAmount =
		+removeSpaces(uzsAmount) +
		+removeSpaces(usdAmount) * removeSpaces(docRate) +
		+removeSpaces(terminalAmount) +
		+removeSpaces(clickAmount)

	const fetchCash = async () => {
		try {
			const url = `api/cashaccounts`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

	const fetchBpBalance = async ({ queryKey }) => {
		const [, clientCode] = queryKey
		if (clientCode) {
			try {
				const url = `api/businesspartners/get-business-partners-balance?cardCode=${clientCode}`
				const { data } = await http.get(url)
				setBpDebt(
					data[0]?.departments?.reduce(
						(acc, item) => acc + item.balance,
						0,
					),
				) || 0
				setBpDebtFc(
					data[0]?.departments?.reduce(
						(acc, item) => acc + item.balanceFC,
						0,
					) || 0,
				)
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const fetchDebtTotal = async ({ queryKey }) => {
		const [, docEntry] = queryKey
		if (docEntry) {
			try {
				const url = `api/sales/sales-order-open-amounts?salesOrderDocEntry=${docEntry}`
				const { data } = await http.get(url)

				return data[0]
			} catch (error) {
				console.log(error)
			}
		}
	}

	const fetchDocRate = async () => {
		try {
			const url = `	api/currency/get-currency-rate`
			const { data } = await http.get(url)

			return data
		} catch (error) {
			console.log(error)
		}
	}

	const { data: cashData = [], isLoading } = useQuery({
		queryKey: ['oneSalesOrder'],
		queryFn: fetchCash,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	const { data: todayDocRate, isLoadingDocRate } = useQuery({
		queryKey: ['docRate'],
		queryFn: fetchDocRate,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	const { data: bpBalanceData = [] } = useQuery({
		queryKey: ['bpBalance', data?.cardCode],
		queryFn: fetchBpBalance,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	const { data: debtTotal = [] } = useQuery({
		queryKey: ['bpBalance', data?.docEntry],
		queryFn: fetchDebtTotal,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	useEffect(() => {
		if (todayDocRate) {
			setDocRate(todayDocRate)
		}
	}, [todayDocRate])

	const postData = async () => {
		setLoading(true)

		const paymentInvoices = (amount) => {
			return [
				{
					lineNum: 0,
					docEntry: data?.docEntry,
					sumApplied: removeSpaces(amount),
					invoiceType:""
				},
			]
		}

		try {
			const onePayment = (cashAdmin, cashNotAdmin, amount, currency) => ({
				cardCode: data?.cardCode,
				docDate: docDate,
				cashAccount: roleNames.includes('admin')
					? cashAdmin
					: cashNotAdmin,
				docCurrency: currency,
				remarks: comment,
				u_DdsArticle: 'Не выбрано',
				u_Department: data?.u_Department || 3, // department
				currency: currency,
				paymentInvoices: paymentInvoices(amount),
			})
			const postData = []

			if (usdAmount) {
				postData.push(
					onePayment(usdCashAcc, usdCashNotAdmin, usdAmount, 'USD'),
				)
			}
			if (uzsAmount) {
				postData.push(
					onePayment(uzsCashAcc, uzdCashNotAdmin, uzsAmount, 'UZS'),
				)
			}
			if (terminalAmount) {
				postData.push(
					onePayment(
						terminalCashAcc,
						terminalCashNotAdmin,
						terminalAmount,
						'UZS',
					),
				)
			}
			if (clickAmount) {
				postData.push(
					onePayment(clickCashAcc, clickCashAcc, clickAmount, 'UZS'),
				)
			}

			console.log(postData)

			await http.post('api/vendorpayments/invoices/batch', postData)
			resetForm()
			successRef.current.open(t('sucCreated'))
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	const resetForm = () => {
		setDocDate(moment().format('YYYY-MM-DD'))
		setComment('')
		setBpDebt('')
		setDocRate('')
		setUsdCashAcc('')
		setUzsCashAcc('')
		setTerminalCashAcc('')
		setClickCashAcc('')
		setUsdAmount('')
		setUzsAmount('')
		setTerminalAmount('')
		setClickAmount('')
		onClose()
	}

	return (
		<Modal
			title={
				<h1 className="font-nunito  font-extrabold text-[#000000]">
					{t('payTitle')}
				</h1>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="55%"
			style={{ height: '70%' }}
		>
			<div className="w-full px-2 sm:px-5">
				<div className="flex items-center justify-between mt-5">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('docRate')}</p>
						<Input
							type="text"
							value={formatNumberWithSpaces(docRate, 2)}
							className=" h-10 w-auto "
							onChange={(e) => {
								setDocRate(e.target.value)
							}}
						/>
					</div>
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('date')}</p>
						<Input
							type="date"
							value={docDate}
							className=" h-10 w-auto "
							onChange={(e) => {
								setDocDate(e.target.value)
							}}
						/>
					</div>
				</div>
				<div className="flex items-center justify-between mt-5">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('selectedFor')}</p>
						<Input
							type="text"
							value={`Наличного расчета`}
							className=" h-10 w-auto "
							disabled
						/>
					</div>
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('docNum')}</p>
						<Input
							type="text"
							value={data?.docNum}
							className=" h-10 w-auto "
							disabled
						/>
					</div>
				</div>

				{/* <div className="flex items-center justify-between mt-5">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('clientDebtUZS')}</p>
						<Input
							type="text"
							value={`${numberWithSpacesIntl(bpBalanceData[0]?.balance * todayDocRate)} UZS`}
							className=" h-10 w-auto "
							disabled
						/>
					</div>
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('clientDebtUSD')}</p>
						<Input
							type="text"
							value={`${numberWithSpacesIntl(bpBalanceData[0]?.balance)} USD`}
							className=" h-10 w-auto "
							disabled
						/>
					</div>
				</div> */}
				<div className="flex items-center justify-between mt-5">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('debtDoc')}</p>
						<Input
							type="text"
							value={`${numberWithSpacesIntl(data?.docCurrency === 'UZS' ? data?.docTotal - data?.paidToDate : data?.docTotal - data?.paidToDateFC)} ${data?.docCurrency}`}
							className=" h-10 w-auto "
							disabled
						/>
					</div>
				</div>

				{/* USD  */}
				<div className="flex items-center gap-3  mt-5">
					<div className="flex flex-col gap-3 w-full">
						<p className="font-bold">{t('USD')}</p>
						<Input
							type="text"
							value={formatNumberWithSpaces(usdAmount, 2)}
							className=" h-10 w-full "
							onChange={(e) => {
								setUsdAmount(e.target.value)
							}}
						/>
					</div>

					{roleNames.includes('admin') && (
						<div className=" flex flex-col  gap-3  ">
							<p className="font-bold">{t('cashAcc')}</p>
							<Select
								type="text"
								onChange={(val) => {
									setUsdCashAcc(val)
								}}
								value={usdCashAcc}
								className="flex h-10 w-[300px] items-center justify-center"
								options={cashData
									?.filter((item) => {
										return (
											item.acctCode.startsWith('50') &&
											(item.actCurr === 'USD' ||
												item.actCurr === '##')
										)
									})
									.map((item) => {
										return {
											value: item.acctCode,
											label: `${item.acctCode}-${item.acctName}`,
										}
									})}
							/>
						</div>
					)}
				</div>

				{/* UZS */}
				<div className="flex items-center gap-3  mt-5">
					<div className="flex flex-col gap-3 w-full">
						<p className="font-bold">{t('uzsCash')}</p>
						<Input
							type="text"
							value={formatNumberWithSpaces(uzsAmount, 2)}
							className=" h-10 w-full "
							onChange={(e) => {
								setUzsAmount(e.target.value)
							}}
						/>
					</div>

					{roleNames.includes('admin') && (
						<div className=" flex flex-col  gap-3  ">
							<p className="font-bold">{t('cashAcc')}</p>
							<Select
								type="text"
								onChange={(val) => {
									setUzsCashAcc(val)
								}}
								value={uzsCashAcc}
								className="flex h-10 w-[300px] items-center justify-center"
								options={cashData
									?.filter((item) => {
										return (
											item.acctCode.startsWith('50') &&
											(item.actCurr === 'UZS' ||
												item.actCurr === '##')
										)
									})
									.map((item) => {
										return {
											value: item.acctCode,
											label: `${item.acctCode}-${item.acctName}`,
										}
									})}
							/>
						</div>
					)}
				</div>

				{/*Click | Payme  */}
				<div className="flex items-center gap-3  mt-5">
					<div className="flex flex-col gap-3 w-full">
						<p className="font-bold">{t('clickCard')}</p>
						<Input
							type="text"
							value={formatNumberWithSpaces(clickAmount, 2)}
							className=" h-10 w-full "
							onChange={(e) => {
								setClickAmount(e.target.value)
							}}
						/>
					</div>

					{roleNames.includes('admin') && (
						<div className=" flex flex-col  gap-3  ">
							<p className="font-bold">{t('cashAcc')}</p>
							<Select
								type="text"
								onChange={(val) => {
									setClickCashAcc(val)
								}}
								value={clickCashAcc}
								className="flex h-10 w-[300px] items-center justify-center"
								options={cashData
									?.filter((item) => {
										return (
											item.acctCode.startsWith('57') &&
											(item.actCurr === 'UZS' ||
												item.actCurr === '##')
										)
									})
									.map((item) => {
										return {
											value: item.acctCode,
											label: `${item.acctCode}-${item.acctName}`,
										}
									})}
							/>
						</div>
					)}
				</div>

				{/* Terminal */}
				<div className="flex items-center gap-3  mt-5">
					<div className="flex flex-col gap-3 w-full">
						<p className="font-bold">{t('terminal')}</p>
						<Input
							type="text"
							value={formatNumberWithSpaces(terminalAmount, 2)}
							className=" h-10 w-full "
							onChange={(e) => {
								setTerminalAmount(e.target.value)
							}}
						/>
					</div>

					{roleNames.includes('admin') && (
						<div className=" flex flex-col  gap-3  ">
							<p className="font-bold">{t('cashAcc')}</p>
							<Select
								type="text"
								onChange={(val) => {
									setTerminalCashAcc(val)
								}}
								value={terminalCashAcc}
								className="flex h-10 w-[300px] items-center justify-center"
								options={cashData
									?.filter((item) => {
										return (
											item.acctCode.startsWith('52') &&
											(item.actCurr === 'UZS' ||
												item.actCurr === '##')
										)
									})
									.map((item) => {
										return {
											value: item.acctCode,
											label: `${item.acctCode}-${item.acctName}`,
										}
									})}
							/>
						</div>
					)}
				</div>

				<div className="flex flex-col gap-3 mt-5 ">
					<p className="font-bold ">{t('totalAmount')}</p>
					<Input
						type="text"
						value={formatNumberWithSpaces(totalAmount, 2)}
						className=" h-10 w-[200px] "
						suffix={'UZS'}
						disabled
					/>
				</div>

				<div className="flex flex-col items-start gap-3 w-full mt-5">
					<p className="font-bold">{t('comments')}</p>
					<TextArea
						onChange={(e) => {
							setComment(e.target.value)
						}}
						value={comment}
						className="w-full"
						rows={4}
					/>
				</div>

				<div className="flex items-center gap-10 mt-14 justify-between">
					<Button
						onClick={() => {
							resetForm()
						}}
						className="w-full bg-red-600 h-[35px] rounded-lg text-white"
					>
						{t('back')}
					</Button>
					<Button
						onClick={postData}
						loading={loading}
						disabled={loading}
						className="w-full bg-[#0A4D68] h-[35px] rounded-lg text-white"
					>
						{t('pay')}
					</Button>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => window.location.reload()}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Modal>
	)
}

export default InvoiceVendorPaymentModal
